<template>
    <div class="container-fluid" id="dvcrud">
        <div class="row">
            <div class="col-md-12">
                <breadcrumb v-bind:bcitens="itensbc" v-bind:mtdcancelar="mtdcancelaredicao"></breadcrumb>
            </div>
            <div class="col-md-12">
                <div id="pnlista" class="card" style="display: none;">
                    <div class="card-header"><span id="titlista">LISTAGEM DE {{ itensbc.item1.titulo }}</span>
                        <router-link to="/">
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                        </router-link>
                    </div>
                    <div class="card-body" style="padding: 10px;">
                        <div class="row">
                            <div class="col-sm-4 col-md-2 col-lg-2">
                                <label for="cbopfiltro">Filtrar:</label>
                                <select name="cbopfiltro" class="form-control form-control-sm" id="cbopfiltro" v-model="pfiltro" @change="mtdlimpar_listagem()">
                                    <option value="0">Código</option>
                                    <option value="1">Descrição</option>
                                </select>
                            </div>
                            <div class="col-sm-8 col-md-6 col-lg-6">
                                <label for="edconteudopesq">Conteúdo da pesquisa:</label>
                                <input id="edconteudopesq" type="text" class="form-control form-control-sm" v-model="pconteudo" @keyup="mtdlimpar_listagem()">
                            </div>
                            <div class="col-6 col-sm-6 col-md-2 col-lg-2">
                                <label for="cbqtdreg">Registros:</label>
                                <select name="cbqtdreg" class="form-control form-control-sm" id="cbqtdreg" v-model="pqtdregistros" @change="mtdlimpar_listagem()">
                                    <option value="10">10</option>
                                    <option value="20">20</option>
                                    <option value="30">30</option>
                                    <option value="40">40</option>
                                    <option value="50">50</option>
                                    <option value="99999999999">Todos</option>
                                </select>
                            </div>
                            <div class="col-6 col-sm-6 col-md-2 col-lg-2">
                                <button type="button" id="btlistar" class="btn btn-primary btn-sm btn-block" @click.prevent="mtdexecutapesquisa()"><i class="fa fa-search"></i> Listar</button>
                            </div>
                            <div class="col-md-12" style="margin-top: 10px;">
                                <vue-bootstrap4-table
                                        :rows="lstcontas"
                                        :columns="columns"
                                        :config="config"
                                        :classes="classes">
                                    <template slot="empty-results">
                                        <div class="col-md-12 text-center">Sem dados para visualização</div>
                                    </template>
                                    <!-- ícones de ordenação da table -->
                                    <template slot="sort-asc-icon">
                                        <i class="fa-icones-ordenacao fa fa-sort-asc"></i>
                                    </template>
                                    <template slot="sort-desc-icon">
                                        <i class="fa-icones-ordenacao fa fa-sort-desc"></i>
                                    </template>
                                    <template slot="no-sort-icon">
                                        <i class="fa-icones-ordenacao fa fa-unsorted"></i>
                                    </template>                                    
                                    <!--  -->                                    
                                    <template slot="id_f" slot-scope="item">
                                        {{ item.row.id }}
                                    </template>
                                    <template slot="opcoes" slot-scope="item">
                                        <button type="button" class="btn btn-info btn-sm btn-opcrud ajt-btn" @click.prevent="mtdalterar(item.row)"><i class="fa fa-edit"></i></button>
                                        <button type="button" class="btn btn-danger btn-sm btn-opcrud ajt-btn" @click.prevent="mtdexcluir(item.row)"><i class="fa fa-trash"></i></button>
                                        <button type="button" class="btn btn-primary btn-sm btn-opcrud ajt-btn" :disabled="ativaDesativaDefNossoNum(item.row.apibanco)" @click.prevent="mtddefinirnossonumero(item.row.id)" title="Definir sequência nosso número"><i class="fa fa-list-ol"></i></button>
                                    </template>
                                    <template slot="api_f" slot-scope="item">
                                        <template v-if="item.row.apibanco == 0">
                                            {{''}}
                                        </template>
                                        <template v-else-if="item.row.apibanco == 1">
                                            Inter API
                                        </template>
                                        <template v-else-if="item.row.apibanco == 2">
                                            Sicredi API
                                        </template>
                                        <template v-else-if="item.row.apibanco == 3">
                                            Sicoob API
                                        </template>
                                        <template v-else-if="item.row.apibanco == 4">
                                            Santander API
                                        </template>
                                        <template v-else-if="item.row.apibanco == 5">
                                            BB API
                                        </template>
                                        <template v-else-if="item.row.apibanco == 21">
                                            Pagar me API
                                        </template>
                                        <template v-else>
                                            Undefined
                                        </template>
                                    </template>
                                </vue-bootstrap4-table>
                            </div>
                            <div class="col-md-12">
                                <ul class="list-group">
                                    <li class="list-group-item d-flex justify-content-between align-items-center" style="padding: 10px;">
                                        Registros
                                        <span class="badge badge-info badge-pill text-right bdg-qtd-reg-info">{{lstcontas.length}}</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="card-footer" style="padding: 10px;">
                        <div class="row">
                            <div class="col-8 col-sm-8 col-md-10 col-lg-10" id="dvpaginacao">
                                <v-pagination
                                        v-model="pagina_atual"
                                        :page-count="pqtd_paginas"
                                        :classes="bootstrapPaginationClasses">
                                </v-pagination>
                            </div>
                            <div class="col-4 col-sm-4 col-md-2 col-lg-2">
                                <button type="button" class="btn btn-success btn-sm btn-block" @click.prevent="mtdnovo()"><i class="fa fa-file"></i> Novo</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div id="pncadastro" class="card" style="display:none;">
                    <div class="card-header"><span>{{itensbc.item2.titulo}}</span>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click.prevent="mtdcancelaredicao()"><span aria-hidden="true">&times;</span></button>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="edid">Código:</label>
                                <input type="text" class="form-control form-control-sm" id="edid" v-model="vid"
                                       maxlength="20" disabled/>
                            </div>
                            <div class="col-sm-12 col-md-6 col-lg-6">
                                <label for="eddescricao">*Descrição:</label>
                                <input type="text" v-model="vdescricao" v-bind:disabled="ativadesativa"
                                       class="form-control form-control-sm" id="eddescricao" maxlength="50">
                            </div>
                            <div class="col-sm-12 col-md-2 col-lg-2">
                              <label for="cbbancos">*Banco:</label>
                              <select id="cbbancos" v-model="vidbanco" v-bind:disabled="ativadesativa"
                                  data-placeholder="Selecione uma opção" data-allow-clear="true"
                                  style="width:100%;">
                              </select>
                            </div>
                            <div class="col-sm-12 col-md-2 col-lg-2">
                              <label for="cbfilial">*Filial:</label>
                              <select id="cbfilial" v-model="vidfilial" v-bind:disabled="ativadesativa" 
                                  data-placeholder="Selecione uma opção" data-allow-clear="true"
                                  style="width:100%;">
                              </select>
                            </div>
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="edagencia">Agência:</label>
                                <input type="text" v-model="vagencia" v-bind:disabled="ativadesativa"
                                    class="form-control form-control-sm" id="edagencia"  maxlength="50"
                                    style="text-transform: uppercase;">
                            </div>
                            <div class="col-sm-12 col-md-1 col-lg-1">
                                <label for="eddigagencia">Dig:</label>
                                <input type="text" v-model="vdigagencia" v-bind:disabled="ativadesativa"
                                    class="form-control form-control-sm" id="eddigagencia"  maxlength="50"
                                    style="text-transform: uppercase;">
                            </div>
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="edconta">Conta:</label>
                                <input type="text" v-model="vconta" v-bind:disabled="ativadesativa"
                                    class="form-control form-control-sm" id="edconta"  maxlength="50"
                                    style="text-transform: uppercase;">
                            </div>
                            <div class="col-sm-12 col-md-1 col-lg-1">
                                <label for="eddigconta">Dig:</label>
                                <input type="text" v-model="vdigconta" v-bind:disabled="ativadesativa"
                                    class="form-control form-control-sm" id="eddigconta"  maxlength="50"
                                    style="text-transform: uppercase;">
                            </div>
                            <div v-show="habilitaCampos" class="col-sm-12 col-md-2 col-lg-2">
                                <label for="edcedente">Cedente:</label>
                                <input type="text" v-model="vcedente" v-bind:disabled="ativadesativa"
                                    class="form-control form-control-sm" id="edcedente"  maxlength="50"
                                    style="text-transform: uppercase;">
                            </div>
                            <div v-show="habilitaCampos" class="col-sm-12 col-md-1 col-lg-1">
                                <label for="eddigcedente">Dig:</label>
                                <input type="text" v-model="vdigcedente" v-bind:disabled="ativadesativa"
                                    class="form-control form-control-sm" id="eddigcedente"  maxlength="50"
                                    style="text-transform: uppercase;">
                            </div>
                            <div  class="col-sm-12 col-md-2 col-lg-2">
                                <label for="edbeneficiario">Beneficiário:</label>
                                <input type="text" v-model="vcodbeneficiario" v-bind:disabled="ativadesativa"
                                    class="form-control form-control-sm" id="edbeneficiario"  maxlength="50"
                                    style="text-transform: uppercase;">
                            </div>
                            <div class="col-sm-12 col-md-1 col-lg-1">
                                <label for="eddigbeneficiario">Dig:</label>
                                <input type="text" v-model="vdigbeneficiario" v-bind:disabled="ativadesativa"
                                    class="form-control form-control-sm" id="eddigbeneficiario"  maxlength="50"
                                    style="text-transform: uppercase;">
                            </div>
                            <div v-show="habilitaCampos" class="col-sm-12 col-md-4 col-lg-4">
                                <label for="edpraca">Praça:</label>
                                <input type="text" v-model="vpraca" v-bind:disabled="ativadesativa"
                                    class="form-control form-control-sm" id="edpraca"  maxlength="50"
                                    style="text-transform: uppercase;">
                            </div>
                            <div v-show="habilitaCampos" class="col-sm-12 col-md-1 col-lg-1">
                                <label for="eduf">UF:</label>
                                <input type="text" v-model="vuf" v-bind:disabled="ativadesativa"
                                    class="form-control form-control-sm" id="eduf"  maxlength="2"
                                    style="text-transform: uppercase;">
                            </div>
                            <div v-show="habilitaCampos" class="col-sm-12 col-md-2 col-lg-2">
                                <label for="edcnpj">CNPJ:</label>
                                <input type="text" v-mask="'##.###.###/####-##'" v-model="vcnpjcpf" v-bind:disabled="ativadesativa"
                                    class="form-control form-control-sm" id="edcnpj"  maxlength="20">
                            </div>
                            <div v-show="habilitaCampos" class="col-sm-12 col-md-5 col-lg-5">
                                <label for="edemitente">Emitente:</label>
                                <input type="text" v-model="vemitente" v-bind:disabled="ativadesativa"
                                    class="form-control form-control-sm" id="edemitente"  maxlength="50"
                                    style="text-transform: uppercase;">
                            </div>
                            <div v-show="habilitaCampos" class="col-sm-12 col-md-1 col-lg-1">
                                <label for="edcarteira">Carteira:</label>
                                <input type="text" v-model="vcarteira" v-bind:disabled="ativadesativa"
                                    class="form-control form-control-sm" id="edcarteira"  maxlength="50"
                                    style="text-transform: uppercase;">
                            </div>
                            <div v-show="habilitaCampos" class="col-sm-12 col-md-1 col-lg-1">
                                <label for="edvariacaocarteira">Variação:</label>
                                <input type="text" v-model="vvariacaocarteira" v-bind:disabled="ativadesativa"
                                    class="form-control form-control-sm" id="edvariacaocarteira"  maxlength="3"
                                    style="text-transform: uppercase;" title="Somente para Banco do Brasil">
                            </div>                            
                            <div v-show="habilitaCampos" class="col-sm-12 col-md-3 col-lg-3">
                                <label for="edconvenio">Convênio:</label>
                                <input type="text" v-model="vconvenio" v-bind:disabled="ativadesativa"
                                    class="form-control form-control-sm" id="edconvenio"  maxlength="50"
                                    style="text-transform: uppercase;">
                            </div>
                            <div v-if="!habilitaCampos" class="col-md-3 col-lg-3"></div> <!-- só pra quebra de linha -->
                            <div class="col-sm-2 col-md-1 col-lg-1">
                                <label for="cbtpchave">Tipo chave pix:</label>
                                <select class="form-control form-control-sm" id="cbtpchave" v-model="vtpchavepix" v-bind:disabled="ativadesativa">
                                    <option value="0">CNPJ</option>
                                    <option value="1">CPF</option>
                                    <option value="2">Celular</option>
                                    <option value="3">Aleatória</option>
                                </select>
                            </div>
                            <div class="col-sm-12 col-md-3 col-lg-3">
                                <label for="edchavepix">Chave Pix:</label>
                                <input type="text" v-model="vchavepix" v-bind:disabled="ativadesativa"
                                    class="form-control form-control-sm" id="edchavepix"  maxlength="50">
                            </div>
                            <div class="col-sm-12 col-md-12 col-lg-12">
                                <label for="edinstrucao1">Instrução(1):</label>
                                <input type="text" v-model="vinstrucao1" v-bind:disabled="ativadesativa"
                                    class="form-control form-control-sm" id="edinstrucao1"  maxlength="50"
                                    style="text-transform: uppercase;">
                            </div>
                            <div class="col-sm-12 col-md-12 col-lg-12">
                                <label for="edinstrucao2">Instrução(2):</label>
                                <input type="text" v-model="vinstrucao2" v-bind:disabled="ativadesativa"
                                    class="form-control form-control-sm" id="edinstrucao2"  maxlength="50"
                                    style="text-transform: uppercase;">
                            </div>
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="eddiasprotesto">Dias protesto:</label>
                                <input type="number" v-model="vdiasprotesto" v-bind:disabled="ativadesativa" min="0"
                                    class="form-control form-control-sm" id="eddiasprotesto"  maxlength="11"
                                    style="text-align: right;">
                            </div>
                            <div v-show="habilitaCampos" class="col-sm-12 col-md-1 col-lg-1">
                                <label for="edespeciedoc">Espécie:</label>
                                <input type="text" v-model="vespeciedoc" v-bind:disabled="ativadesativa"
                                    class="form-control form-control-sm" id="edespeciedoc"  maxlength="2"
                                    style="text-transform: uppercase;">
                            </div>
                            <div v-show="habilitaCampos" class="col-sm-2 col-md-2 col-lg-2">
                                <label for="cbaceite">Aceite:</label>
                                <select class="form-control form-control-sm" id="cbaceite" v-model="vaceite" v-bind:disabled="ativadesativa">
                                    <option value="0">Não</option>
                                    <option value="1">Sim</option>
                                </select>
                            </div>
                            <div v-show="habilitaCampos" class="col-sm-2 col-md-2 col-lg-2">
                                <label for="cblayoutremessa">Layout remessa:</label>
                                <select class="form-control form-control-sm" id="cblayoutremessa" v-model="vlayoutremessa" v-bind:disabled="ativadesativa">
                                    <option value="0">cnab240</option>
                                    <option value="1">cnab240_SIACC</option>
                                    <option value="2">cnab240_SIGCB</option>
                                    <option value="3">cnab400</option>
                                </select>
                            </div>
                            <div class="col-sm-12 col-md-11 col-lg-11 card mx-auto" 
                                style="margin-bottom: 15px; margin-top: 20px; padding-block: 15px; background-color:#e9ecef">
                                <div class="row mb-3">
                                    <div class="col-sm-4 col-md-6 col-lg-2">
                                        <label for="cbapibanco">API Banco:</label>
                                        <select class="form-control form-control-sm" id="cbapibanco" v-model="vapibanco" v-bind:disabled="ativadesativa">
                                            <option value="0">Nenhum</option>
                                            <option value="1">Banco Inter</option>
                                            <option value="2">Banco Sicredi</option>
                                            <option value="3">Banco Sicoob</option>
                                            <option value="4">Banco Santander</option>
                                            <option value="5">Banco do Brasil</option>
                                            <option value="21">Gateway Pagar Me</option>
                                        </select>
                                    </div>
                                    <!-- tipo api -->
                                    <div v-show="vapibanco == 1" class="col-sm-4 col-md-6 col-lg-2">
                                        <label for="cbtipoapi">*Tipo API:</label>
                                        <select class="form-control form-control-sm" id="cbtipoapi" v-model="vtipoapi" v-bind:disabled="ativadesativaapi">
                                            <option value="0">Boleto</option>
                                            <option value="1">Pix</option>
                                        </select>
                                    </div>
                                    <div class="col-sm-4 col-md-4 col-lg-4 d-flex">
                                        <div class="custom-control custom-switch" style="margin-top: 25px;">
                                            <input type="checkbox" class="custom-control-input" id="cbapiteste" v-model="vapiteste" v-bind:disabled="ativadesativacheck">
                                            <label class="custom-control-label" for="cbapiteste" >SANDBOX (Efetuar testes)</label>
                                        </div>
                                        <!-- Botão para configurar webhook -->
                                        <button v-show="vapibanco > 0" type="button" class="btn-config-whook" title="Configurar Webhook" @click.prevent="mtdconfigurarwebhook()">
                                            <i class="fa fa-wifi" aria-hidden="true"></i>
                                        </button>
                                    </div>
                                    <div v-if="vapibanco == 1 && vapiteste" class="col-sm-8 mt-3">
                                        <h5 style="font-size: 16px; color: #545b62; margin-top: 5px;">
                                            *Preencher campos <strong style="color: #ff7a00">Client ID, Client Secret, Arquivos de Chave e Certificado</strong> com os dados
                                            da aplicação sandbox.
                                        </h5>
                                    </div>   
                                    <div v-if="vapibanco == 21 && vapiteste" class="col-sm-8 mt-3">
                                        <h5 style="font-size: 16px; color: #545b62; margin-top: 5px;">
                                            *Preencher campos <strong style="color: green">Chave Pública e Chave Privada</strong> com os dados
                                            da aplicação sandbox.
                                        </h5>
                                    </div>   
                                    <template v-if="vapibanco == 2 && !vapiteste">  <!-- FORM API SICREDI -->
                                        <div class="col-sm-4 col-md-2 col-lg-3">
                                            <label for="cbtipocobranca">*Tipo Cobrança:</label>
                                            <select class="form-control form-control-sm" id="cbtipocobranca" v-model="vtipocobranca" 
                                            placeholder="Selecione uma opção" v-bind:disabled="ativadesativaapi">
                                                <option value="" selected disabled hidden>Selecione uma opção</option>
                                                <option value="NORMAL">Normal (Boletos sem QR Code)</option>
                                                <option value="HIBRIDO">Hibrido (Boletos com QR Code)</option>
                                            </select>
                                        </div>     
                                        <div class="col-sm-12 col-md-2 col-lg-2">
                                            <label for="edcodcooperativa">*Cooperativa:</label>
                                            <input type="text" v-model="vcodcooperativa" v-bind:disabled="ativadesativaapi"
                                                class="form-control form-control-sm" id="edcodcooperativa"  maxlength="4"
                                                style="text-transform: uppercase;">
                                        </div>
                                        <div class="col-sm-12 col-md-1 col-lg-1">
                                            <label for="edcodposto">*Posto:</label>
                                            <input type="text" v-model="vcodposto" v-bind:disabled="ativadesativaapi"
                                                class="form-control form-control-sm" id="edcodposto"  maxlength="2"
                                                style="text-transform: uppercase;">
                                        </div> 
                                        <div class="col-sm-12 col-md-6 col-lg-6 mt-3">
                                            <label for="edaccesstoken">*Token de Acesso:</label>
                                            <input type="text" v-model="vaccesstoken" v-bind:disabled="ativadesativaapi"
                                                class="form-control form-control-sm" id="edaccesstoken" maxlength="50">
                                        </div>
                                        <div class="col-sm-12 col-md-6 col-lg-6 mt-3">
                                            <label for="edcodacesso">*Cód. de Acesso:</label>
                                            <input type="text" v-model="vcodacesso" v-bind:disabled="ativadesativaapi"
                                                class="form-control form-control-sm" id="edcodacesso" maxlength="64">
                                        </div>
                                        <div class="col-sm-8 mt-3">
                                            <h5 style="font-size: 16px; color: #545b62; margin-top: 5px;">
                                                *Os campos <strong style="color: #17723c">Agência, Conta, Beneficiário e Emitente</strong> precisam ser 
                                                preenchidos para a API selecionada.
                                            </h5>
                                            <h5 style="font-size: 16px; color: #545b62; margin-top: 5px;">
                                                    *Os dados <strong style="color: #17723c;">Praça, UF e CNPJ</strong> serão definidos pelo cadastro da filial.
                                            </h5>
                                        </div>   
                                    </template>
                                    <div v-if="vapibanco == 5" class="col-sm-12 col-md-6 col-lg-6">
                                        <label for="edapplicationkey">*Application Key:</label>
                                        <input type="text" v-model="vapplicationkey" v-bind:disabled="ativadesativaapi"
                                            class="form-control form-control-sm" id="edapplicationkey"
                                            style="text-transform: uppercase;">
                                    </div>
                                </div>
                                <template v-if="vapibanco == 1"> <!-- FORM API INTER -->
                                    <div class="row">
                                        <div class="col-sm-12 col-md-6 col-lg-6">
                                            <label for="edclientid">*Client ID:</label>
                                            <input type="text" v-model="vclientid" v-bind:disabled="ativadesativaapi"
                                                class="form-control form-control-sm" id="edclientid" maxlength="50">
                                        </div>
                                        <div class="col-sm-12 col-md-6 col-lg-6">
                                            <label for="edclientsecret">*Client Secret:</label>
                                            <input type="text" v-model="vclientsecret" v-bind:disabled="ativadesativaapi"
                                                class="form-control form-control-sm" id="edclientsecret" maxlength="50">
                                        </div>
                                        <div v-if="!vdiretorioarquivokey" class="col-md-6" style="margin-top: 15px;">
                                            <input
                                                type="file" 
                                                id="btenviararquivokey"
                                                accept=".key"  
                                                style="display: none;"
                                                @change="mtenviararquivo">                                                                
                                            <button type="button" style="width: 100%; background-color: #ff7a00; border: #ffb46e;" class="btn btn-warning" @click.prevent="mtdisparabtenviarquivokey()"><i class="fa fa-key"></i> Selecionar arquivo chave</button>
                                        </div>
                                        <div v-if="vdiretorioarquivokey" class="col-md-6" style="margin-top: 15px;">
                                            <ul class="list-group">
                                                <li class="list-group-item list-group-item-action">
                                                    <div class="row">
                                                        <div class="col-md-1 text-center">
                                                            <i class="fa fa-check" style="font-size: 26px; color: #17723c;"></i>
                                                        </div>
                                                        <div class="col-md-11">                                                                                
                                                            <div class="col-md-12">
                                                                <a v-bind:href="'https://'+$store.state.usuario.adrsrv+'/controller/rtbaixaarquivosinter.php?localarquivo=../'+vdiretorioarquivokey" class="btn btn-warning" target="_blank" title="Baixar chave" style="background-color: #ff7a00; width: 150px;">
                                                                    <i class="fa fa-download"></i> Baixar chave
                                                                </a>
                                                                <h5 style="font-size: 18px; color: #6c757d; font-weight: bold; margin-bottom: -1px;"></h5>
                                                            </div>
                                                            <div class="col-md-12" style="margin-top: 10px;">
                                                                <span id="op_exc_cert" @click.prevent="mtdeletararquivo('key')"><i class="fa fa-lock"></i> <strong>Remover chave</strong></span><br>
                                                            </div>
                                                        </div>
                                                    </div>                                                                                                                                                
                                                </li>
                                            </ul>
                                        </div>
                                        <div v-if="!vdiretorioarquivocrt" class="col-md-6" style="margin-top: 15px;">
                                            <input
                                                type="file" 
                                                id="btenviararquivocert"
                                                accept=".crt"  
                                                style="display: none;"
                                                @change="mtenviararquivo">                                                                
                                            <button type="button" style="width: 100%; background-color: #ff7a00; border: #ffb46e;" class="btn btn-success btn-verde" @click.prevent="mtdisparabtenviarquivocert()"><i class="fa fa-certificate"></i> Selecionar arquivo de certificado</button>
                                        </div>
                                        <div v-if="vdiretorioarquivocrt" class="col-md-6" style="margin-top: 15px;">
                                            <ul class="list-group">
                                                <li class="list-group-item list-group-item-action">
                                                    <div class="row">
                                                        <div class="col-md-1 text-center">
                                                            <i class="fa fa-check" style="font-size: 26px; color: #17723c;"></i>
                                                        </div>
                                                        <div class="col-md-11">                                                                                
                                                            <div class="col-md-12">
                                                                <a v-bind:href="'https://'+$store.state.usuario.adrsrv+'/controller/rtbaixaarquivosinter.php?localarquivo=../'+vdiretorioarquivocrt" class="btn btn-warning" target="_blank" title="Baixar chave" style="background-color: #ff7a00; width: 180px;">
                                                                    <i class="fa fa-download"></i> Baixar certificado
                                                                </a>
                                                                <h5 style="font-size: 18px; color: #6c757d; font-weight: bold; margin-bottom: -1px;"></h5>
                                                            </div>
                                                            <div class="col-md-12" style="margin-top: 10px;">
                                                                <span id="op_exc_cert" @click.prevent="mtdeletararquivo('crt')"><i class="fa fa-lock"></i> <strong>Remover certificado</strong></span><br>
                                                            </div>
                                                        </div>
                                                    </div>                                                                                                                                                
                                                </li>
                                            </ul>
                                        </div>
                                        <div class="col-sm-8 mt-3">
                                            <h5 style="font-size: 16px; color: #545b62; margin-top: 5px;">
                                                *Os campos <strong style="color: #ff7a00;">Agência, Conta e Emitente</strong> precisam ser 
                                                preenchidos para a API selecionada.
                                            </h5>
                                            <h5 style="font-size: 16px; color: #545b62; margin-top: 5px;">
                                                *Os dados <strong style="color: #ff7a00;">Praça, UF e CNPJ</strong> serão definidos pelo cadastro da filial.
                                            </h5>
                                        </div>
                                    </div>             
                                </template>     

                                <template v-if="vapibanco == 3"> <!-- FORM API SICOOB -->
                                    <div class="row">
                                            <div class="col-sm-12 col-md-6 col-lg-6">
                                                <label for="edclientid">*Client ID:</label>
                                                <input type="text" v-model="vclientid" v-bind:disabled="ativadesativaapi"
                                                    class="form-control form-control-sm" id="edclientid" maxlength="50">
                                            </div>
                                            <div class="col-sm-12 col-md-6 col-lg-6">
                                            </div>
                                            <div v-if="!vdiretorioarquivokey" class="col-md-6" style="margin-top: 15px;">
                                                <input
                                                    type="file" 
                                                    id="btenviararquivokey"
                                                    accept=".key"  
                                                    style="display: none;"
                                                    @change="mtenviararquivo">                                                                
                                                <button type="button" style="width: 100%; background-color: #00461c; border: #ffb46e;" class="btn btn-warning" @click.prevent="mtdisparabtenviarquivokey()"><i class="fa fa-key"></i> Selecionar arquivo chave</button>
                                            </div>
                                            <div v-if="vdiretorioarquivokey" class="col-md-6" style="margin-top: 15px;">
                                                <ul class="list-group">
                                                    <li class="list-group-item list-group-item-action">
                                                        <div class="row">
                                                            <div class="col-md-1 text-center">
                                                                <i class="fa fa-check" style="font-size: 26px; color: #17723c;"></i>
                                                            </div>
                                                            <div class="col-md-11">                                                                                
                                                                <div class="col-md-12">
                                                                    <a v-bind:href="'https://'+$store.state.usuario.adrsrv+'/controller/rtbaixaarquivosinter.php?localarquivo=../'+vdiretorioarquivokey" class="btn btn-warning" target="_blank" title="Baixar chave" style="background-color: #00461c; width: 150px;">
                                                                        <i class="fa fa-download"></i> Baixar chave
                                                                    </a>
                                                                    <h5 style="font-size: 18px; color: #6c757d; font-weight: bold; margin-bottom: -1px;"></h5>
                                                                </div>
                                                                <div class="col-md-12" style="margin-top: 10px;">
                                                                    <span id="op_exc_cert" @click.prevent="mtdeletararquivo('key')"><i class="fa fa-lock"></i> <strong>Remover chave</strong></span><br>
                                                                </div>
                                                            </div>
                                                        </div>                                                                                                                                                
                                                    </li>
                                                </ul>
                                            </div>
                                            <div v-if="!vdiretorioarquivocrt" class="col-md-6" style="margin-top: 15px;">
                                                <input
                                                    type="file" 
                                                    id="btenviararquivocert"
                                                    accept=".crt"  
                                                    style="display: none;"
                                                    @change="mtenviararquivo">                                                                
                                                <button type="button" style="width: 100%; background-color: #00461c; border: #ffb46e;" class="btn btn-success btn-verde" @click.prevent="mtdisparabtenviarquivocert()"><i class="fa fa-certificate"></i> Selecionar arquivo de certificado</button>
                                            </div>
                                            <div v-if="vdiretorioarquivocrt" class="col-md-6" style="margin-top: 15px;">
                                                <ul class="list-group">
                                                    <li class="list-group-item list-group-item-action">
                                                        <div class="row">
                                                            <div class="col-md-1 text-center">
                                                                <i class="fa fa-check" style="font-size: 26px; color: #17723c;"></i>
                                                            </div>
                                                            <div class="col-md-11">                                                                                
                                                                <div class="col-md-12">
                                                                    <a v-bind:href="'https://'+$store.state.usuario.adrsrv+'/controller/rtbaixaarquivosinter.php?localarquivo=../'+vdiretorioarquivocrt" class="btn btn-warning" target="_blank" title="Baixar chave" style="background-color: #00461c; width: 180px;">
                                                                        <i class="fa fa-download"></i> Baixar certificado
                                                                    </a>
                                                                    <h5 style="font-size: 18px; color: #6c757d; font-weight: bold; margin-bottom: -1px;"></h5>
                                                                </div>
                                                                <div class="col-md-12" style="margin-top: 10px;">
                                                                    <span id="op_exc_cert" @click.prevent="mtdeletararquivo('crt')"><i class="fa fa-lock"></i> <strong>Remover certificado</strong></span><br>
                                                                </div>
                                                            </div>
                                                        </div>                                                                                                                                                
                                                    </li>
                                                </ul>
                                            </div>
                                            <div class="col-sm-8 mt-3">
                                                <h5 style="font-size: 16px; color: #545b62; margin-top: 5px;">
                                                    *Os campos <strong style="color: #00461c;">Agência e Conta</strong> precisam ser 
                                                    preenchidos para a API selecionada.
                                                </h5>
                                                <h5 style="font-size: 16px; color: #545b62; margin-top: 5px;">
                                                    *Os dados <strong style="color: #00461c;">Praça, UF e CNPJ</strong> serão definidos pelo cadastro da filial.
                                                </h5>
                                            </div>
                                        </div>             
                                </template>     
                                <template v-if="vapibanco == 4"> <!-- FORM API SANTANDER -->
                                    <div class="row">
                                        <template v-if="opcrud == 2">                                                            
                                            <template v-if="!vworkspaceid">
                                                <div class="col-md-6" style="margin-top: 15px;">
                                                    <button type="button" style="width: 100%; background-color: darkred; border: darkred;" class="btn btn-warning" @click.prevent="mtdconfirmagerarworkspacesantander()"><i class="fa fa-cloud"></i> Iniciar workspace</button>
                                                </div>
                                            </template>
                                            <template v-else>
                                                <div class="col-md-3" style="margin-top: 15px;">
                                                    <label for="edworkspaceid">Workspace ID:</label>
                                                    <input type="text" v-model="vworkspaceid" disabled style="background-color: whitesmoke;"
                                                    class="form-control form-control-sm" id="edworkspaceid">
                                                </div>
                                                <div class="col-md-1" style="margin-top: auto;">
                                                    <button type="button" style="width: 100%; background-color: darkred; border: darkred;" class="btn btn-sm btn-warning" @click.prevent="mtdconfirmalimparwebhooksantander()"><i class="fa fa-chain-broken" aria-hidden="true"></i></button>
                                                </div>
                                            </template>
                                        </template>
                                    </div>
                                    <div class="row">
                                            <div class="col-sm-12 col-md-6 col-lg-6">
                                                <label for="edclientid">*Client ID:</label>
                                                <input type="text" v-model="vclientid" v-bind:disabled="ativadesativaapi"
                                                    class="form-control form-control-sm" id="edclientid" maxlength="50">
                                            </div>
                                            <div class="col-sm-12 col-md-6 col-lg-6">
                                                <label for="edclientsecret">*Client Secret:</label>
                                                <input type="text" v-model="vclientsecret" v-bind:disabled="ativadesativaapi"
                                                    class="form-control form-control-sm" id="edclientsecret" maxlength="50">
                                            </div>
                                            <div v-if="!vdiretorioarquivokey" class="col-md-6" style="margin-top: 15px;">
                                                <input
                                                    type="file" 
                                                    id="btenviararquivokey"
                                                    accept=".key"  
                                                    style="display: none;"
                                                    @change="mtenviararquivo">                                                                
                                                <button type="button" style="width: 100%; background-color: darkred; border: darkred;" class="btn btn-warning" @click.prevent="mtdisparabtenviarquivokey()"><i class="fa fa-key"></i> Selecionar arquivo chave</button>
                                            </div>
                                            <div v-if="vdiretorioarquivokey" class="col-md-6" style="margin-top: 15px;">
                                                <ul class="list-group">
                                                    <li class="list-group-item list-group-item-action">
                                                        <div class="row">
                                                            <div class="col-md-1 text-center">
                                                                <i class="fa fa-check" style="font-size: 26px; color: #17723c;"></i>
                                                            </div>
                                                            <div class="col-md-11">                                                                                
                                                                <div class="col-md-12">
                                                                    <a v-bind:href="'https://'+$store.state.usuario.adrsrv+'/controller/rtbaixaarquivosinter.php?localarquivo=../'+vdiretorioarquivokey" class="btn btn-warning" target="_blank" title="Baixar chave" style="background-color: darkred; width: 60%;">
                                                                        <i class="fa fa-download"></i> Baixar chave
                                                                    </a>
                                                                    <h5 style="font-size: 18px; color: red; font-weight: bold; margin-bottom: -1px;"></h5>
                                                                </div>
                                                                <div class="col-md-12" style="margin-top: 10px;">
                                                                    <span id="op_exc_cert" @click.prevent="mtdeletararquivo('key')"><i class="fa fa-lock"></i> <strong>Remover chave</strong></span><br>
                                                                </div>
                                                            </div>
                                                        </div>                                                                                                                                                
                                                    </li>
                                                </ul>
                                            </div>
                                            <div v-if="!vdiretorioarquivocrt" class="col-md-6" style="margin-top: 15px;">
                                                <input
                                                    type="file" 
                                                    id="btenviararquivocert"
                                                    accept=".crt"  
                                                    style="display: none;"
                                                    @change="mtenviararquivo">                                                                
                                                <button type="button" style="width: 100%; background-color:darkred; border: darkred;" class="btn btn-success btn-verde" @click.prevent="mtdisparabtenviarquivocert()"><i class="fa fa-certificate"></i> Selecionar arquivo de certificado</button>
                                            </div>
                                            <div v-if="vdiretorioarquivocrt" class="col-md-6" style="margin-top: 15px;">
                                                <ul class="list-group">
                                                    <li class="list-group-item list-group-item-action">
                                                        <div class="row">
                                                            <div class="col-md-1 text-center">
                                                                <i class="fa fa-check" style="font-size: 26px; color: #17723c;"></i>
                                                            </div>
                                                            <div class="col-md-11">                                                                                
                                                                <div class="col-md-12">
                                                                    <a v-bind:href="'https://'+$store.state.usuario.adrsrv+'/controller/rtbaixaarquivosinter.php?localarquivo=../'+vdiretorioarquivocrt" class="btn btn-warning" target="_blank" title="Baixar chave" style="background-color: darkred; width: 60%;">
                                                                        <i class="fa fa-download"></i> Baixar certificado
                                                                    </a>
                                                                    <h5 style="font-size: 18px; color: darkred ; font-weight: bold; margin-bottom: -1px;"></h5>
                                                                </div>
                                                                <div class="col-md-12" style="margin-top: 10px;">
                                                                    <span id="op_exc_cert" @click.prevent="mtdeletararquivo('crt')"><i class="fa fa-lock"></i> <strong>Remover certificado</strong></span><br>
                                                                </div>
                                                            </div>
                                                        </div>                                                                                                                                                
                                                    </li>
                                                </ul>
                                            </div>
                                            <div class="col-sm-8 mt-3">
                                                <h5 style="font-size: 16px; color: #545b62; margin-top: 5px;">
                                                    *Os campos <strong style="color: darkred">Agência, Conta, Beneficiário, Emitente e Convênio</strong> precisam ser 
                                                    preenchidos para a API selecionada.
                                                </h5>
                                                <h5 style="font-size: 16px; color: #545b62; margin-top: 5px;">
                                                        *Os dados <strong style="color: darkred;">Praça, UF e CNPJ</strong> serão definidos pelo cadastro da filial.
                                                </h5>
                                            </div>
                                        </div>             
                                </template>
                                <template v-if="vapibanco == 5"> <!-- FORM API BB -->
                                    <div class="row">
                                            <div class="col-sm-12 col-md-6 col-lg-6">
                                                <label for="edclientid">*Client ID:</label>
                                                <input type="text" v-model="vclientid" v-bind:disabled="ativadesativaapi"
                                                    class="form-control form-control-sm" id="edclientid" maxlength="50">
                                            </div>
                                            <div class="col-sm-12 col-md-6 col-lg-6">
                                                <label for="edclientsecret">*Client Secret:</label>
                                                <input type="text" v-model="vclientsecret" v-bind:disabled="ativadesativaapi"
                                                    class="form-control form-control-sm" id="edclientsecret" maxlength="50">
                                            </div>
                                            <div v-if="!vdiretorioarquivokey" class="col-md-6" style="margin-top: 15px;">
                                                <input
                                                    type="file" 
                                                    id="btenviararquivokey"
                                                    accept=".key"  
                                                    style="display: none;"
                                                    @change="mtenviararquivo">                                                                
                                                <button type="button" style="width: 100%; background-color: #ffe600; border: blue 1px solid; color: blue;" class="btn btn-warning" @click.prevent="mtdisparabtenviarquivokey()"><i class="fa fa-key"></i> Selecionar arquivo chave</button>
                                            </div>
                                            <div v-if="vdiretorioarquivokey" class="col-md-6" style="margin-top: 15px;">
                                                <ul class="list-group">
                                                    <li class="list-group-item list-group-item-action">
                                                        <div class="row">
                                                            <div class="col-md-1 text-center">
                                                                <i class="fa fa-check" style="font-size: 26px; color: #17723c;"></i>
                                                            </div>
                                                            <div class="col-md-11">                                                                                
                                                                <div class="col-md-12">
                                                                    <a v-bind:href="'https://'+$store.state.usuario.adrsrv+'/controller/rtbaixaarquivosinter.php?localarquivo=../'+vdiretorioarquivokey" class="btn btn-warning" target="_blank" title="Baixar chave" style="background-color: #ffe600; color: blue; border: 1px solid blue; width: 60%;">
                                                                        <i class="fa fa-download"></i> Baixar chave
                                                                    </a>
                                                                    <h5 style="font-size: 18px; color: blue; font-weight: bold; margin-bottom: -1px;"></h5>
                                                                </div>
                                                                <div class="col-md-12" style="margin-top: 10px;">
                                                                    <span id="op_exc_cert" @click.prevent="mtdeletararquivo('key')"><i class="fa fa-lock"></i> <strong>Remover chave</strong></span><br>
                                                                </div>
                                                            </div>
                                                        </div>                                                                                                                                                
                                                    </li>
                                                </ul>
                                            </div>
                                            <div v-if="!vdiretorioarquivocrt" class="col-md-6" style="margin-top: 15px;">
                                                <input
                                                    type="file" 
                                                    id="btenviararquivocert"
                                                    accept=".crt"  
                                                    style="display: none;"
                                                    @change="mtenviararquivo">                                                                
                                                <button type="button" style="width: 100%; background-color: #ffe600; border: blue 1px solid; color: blue;" class="btn btn-success btn-verde" @click.prevent="mtdisparabtenviarquivocert()"><i class="fa fa-certificate"></i> Selecionar arquivo de certificado</button>
                                            </div>
                                            <div v-if="vdiretorioarquivocrt" class="col-md-6" style="margin-top: 15px;">
                                                <ul class="list-group">
                                                    <li class="list-group-item list-group-item-action">
                                                        <div class="row">
                                                            <div class="col-md-1 text-center">
                                                                <i class="fa fa-check" style="font-size: 26px; color: #17723c;"></i>
                                                            </div>
                                                            <div class="col-md-11">                                                                                
                                                                <div class="col-md-12">
                                                                    <a v-bind:href="'https://'+$store.state.usuario.adrsrv+'/controller/rtbaixaarquivosinter.php?localarquivo=../'+vdiretorioarquivocrt" class="btn btn-warning" target="_blank" title="Baixar chave" style="background-color: #ffe600; color: blue; border: 1px solid blue; width: 60%;">
                                                                        <i class="fa fa-download"></i> Baixar certificado
                                                                    </a>
                                                                    <h5 style="font-size: 18px; color: blue ; font-weight: bold; margin-bottom: -1px;"></h5>
                                                                </div>
                                                                <div class="col-md-12" style="margin-top: 10px;">
                                                                    <span id="op_exc_cert" @click.prevent="mtdeletararquivo('crt')"><i class="fa fa-lock"></i> <strong>Remover certificado</strong></span><br>
                                                                </div>
                                                            </div>
                                                        </div>                                                                                                                                                
                                                    </li>
                                                </ul>
                                            </div>
                                            <div class="col-sm-8 mt-3">
                                                <h5 style="font-size: 16px; color: #545b62; margin-top: 5px;">
                                                    *Os campos <strong style="color: blue">Agência, Conta, Carteira, Variação e Convênio</strong> precisam ser 
                                                    preenchidos para a API selecionada.
                                                </h5>
                                                <h5 style="font-size: 16px; color: #545b62; margin-top: 5px;">
                                                        *Os dados <strong style="color: blue;">Praça, UF e CNPJ</strong> serão definidos pelo cadastro da filial.
                                                </h5>
                                            </div>
                                        </div>             
                                </template>
                                <template v-if="vapibanco == 21"> <!-- FORM API PAGARME -->
                                    <div class="row">
                                        <div class="col-sm-12 col-md-6 col-lg-6">
                                            <label for="edchavepublica">*Chave Pública:</label>
                                            <input type="text" v-model="vchavepublica" v-bind:disabled="ativadesativaapi"
                                                class="form-control form-control-sm" id="edchavepublica" maxlength="50">
                                        </div>
                                        <div class="col-sm-12 col-md-6 col-lg-6">
                                            <label for="edchaveprivada">*Chave Privada:</label>
                                            <input type="text" v-model="vchaveprivada" v-bind:disabled="ativadesativaapi"
                                                class="form-control form-control-sm" id="edchaveprivada" maxlength="50">
                                        </div>
                                        <div class="col-sm-8 mt-3">
                                            <h5 style="font-size: 16px; color: #545b62; margin-top: 5px;">
                                                *Somente os campos <strong style="color: green;">Descrição, Banco e Filial</strong> precisam ser
                                                preenchidos para a API selecionada.
                                            </h5>
                                        </div>
                                    </div>
                                </template>         
                            </div>       
                        </div>
                    </div>
                    <div class="card-footer">
                        <div class="row">
                            <div class="col-sm-8">
                                <h5 style="font-size: 16px; color: #545b62; margin-top: 5px;"><strong>Campos com asterisco(*) devem ser informados</strong>.</h5>
                            </div>
                            <div class="col-sm-2">
                                <button id="btgravar" v-if="(opcrud == 1)" type="button" @click.prevent="mtdgravar()"
                                        v-bind:disabled="validou" class="btn btn-primary btn-sm"
                                        style="width:100%; margin-bottom:10px;"><i class="fa fa-check"></i> Gravar
                                </button>
                                <button id="btgravar" v-else-if="(opcrud == 2)" type="button" @click.prevent="mtdgravar()"
                                        v-bind:disabled="validou" class="btn btn-primary btn-sm"
                                        style="width:100%; margin-bottom:10px;"><i class="fa fa-check"></i> Alterar
                                </button>
                                <button id="btgravar" v-else-if="(opcrud == 3)" type="button" @click.prevent="mtdgravar()"
                                        v-bind:disabled="validou" class="btn btn-primary btn-sm"
                                        style="width:100%; margin-bottom:10px;"><i class="fa fa-check"></i> Excluir
                                </button>
                            </div>
                            <div class="col-sm-2">
                                <button type="button" @click.prevent="mtdcancelaredicao()" class="btn btn-secondary btn-sm" style="width:100%">
                                    <i class="fa fa-close"></i> Cancelar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal" id="mddefinirnossonumero">
            <div class="modal-dialog modal-sm modal-dialog-centered">
            <div class="modal-content">            
                <div class="modal-header">
                    <h4 class="modal-title">Definir nosso número</h4>
                    <button type="button" class="close" data-dismiss="modal">&times;</button>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-sm-12 col-md-12 col-lg-12">
                            <label for="ednossonumero">Sequência nosso número:</label>
                            <input type="number" class="form-control form-control-sm" id="ednossonumero" v-model="vnossonumero" maxlength="11"/>
                        </div>                        
                    </div>
                </div>
                <div class="modal-footer">
					<button type="button" class="btn btn-primary btn-sm" @click.prevent="mtconfirmarnossonumero()"><i class="fa fa-check"></i> Confirmar</button>
					<button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal"><i class="fa fa-close"></i> Cancelar</button>
                </div>                
            </div>
            </div>
        </div>
        <modal name="mdl-config-webhook" :adaptive="true" height="auto" :styles="'background-color: transparent;'">
            <div class="card">
                <div class="card-header" style="height: 43px; border-top-left-radius: 5px;">
                    <h4 style="font-size: 18px;"><i class="fa fa-wifi" aria-hidden="true"></i> Configuração do webhook</h4>
                </div>
                <div class="card-body">
                    <div class="card" style="margin-bottom: 15px; padding: 15px;">
                        <div class="row">
                            <div class="col-sm-12 col-md-7 col-lg-7">
                                <label for="edchavepix">Chave Pix:</label>
                                <input type="text" v-model="vchavepix"
                                class="form-control form-control-sm" id="edchavepix"  maxlength="50" :disabled="vtipoapi == 0">
                            </div>
                            <div class="col-sm-12 col-md-5 col-lg-5">
                                <!-- botão para buscar os webhooks -->
                                <button v-if="vchavepix && vtipoapi == 1" type="button" class="btn btn-primary btn-sm" style="margin-top: 20px; width: 100%;" title="Buscar Webhooks" @click.prevent="mtdlistawebhooks()">
                                    <i class="fa fa-globe" aria-hidden="true"></i> Consultar por chave
                                </button>
                                <button v-else type="button" class="btn btn-primary btn-sm" style="margin-top: 20px; width: 100%;" title="Buscar Webhooks" @click.prevent="mtdlistawebhooks()">
                                    <i class="fa fa-globe" aria-hidden="true"></i> Consultar
                                </button>
                            </div>
                            <div class="col-sm-12 col-md-9 col-lg-9">
                                <label for="edurlwebhook">URL do webhook:</label>
                                <input type="text" class="form-control form-control-sm" id="edurlwebhook" v-model="vurlwebhook" maxlength="100"/>
                            </div>
                            <div class="col-sm-12 col-md-3 col-lg-3">
                                <button v-if="vurlwebhook" @click.prevent="mtdconfirmacadastrowebhook()" type="button" class="btn btn-primary btn-sm" style="margin-top: 20px; width: 100%;" title="Vincular URL">
                                    <i class="fa fa-link" aria-hidden="true"></i> Vincular
                                </button>
                            </div>
                        </div>
                    </div>
                    <template v-if="lstwebhooksapi.length > 0">
                        <div v-for="item in lstwebhooksapi" class="card" style="border: 1px solid black !important; margin-bottom: 15px; padding-inline: 15px; background-color:#e9ecef">
                            <div class="row">
                                <!-- lista de webhooks -->
                                <div class="col-sm-12 col-md-12 col-lg-12">
                                    <div class="table-responsive">
                                        <table class="table table-sm table-bordered table-hover" style="margin-bottom: 0px;">
                                            <thead class="thead-light">
                                                <tr>
                                                    <th v-show="item.chave">Chave Pix</th>
                                                    <th>URL Webhook</th>
                                                    <th></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td v-show="item.chave">{{item.chave}}</td>
                                                    <td>{{item.webhookUrl}}</td>
                                                    <td  style="display: flex; justify-content: flex-end;">
                                                        <button title="Desvincular URL" type="button" class="btn btn-danger btn-sm" style="margin-left: auto;" @click.prevent="mtdconfirmadesvincularwebhook(item)">
                                                            <i class="fa fa-chain-broken" aria-hidden="true"></i>
                                                        </button>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </template>
                </div>
                <div class="card-footer" style="padding: 15px;">
                    <div class="btns-config-whook">
                        <button @click.prevent="mtdcancelaconfigwebhook()" class="btn btn-secondary btn-sm">Fechar <i class="fa fa-sign-out"></i></button>
                    </div>    
                </div>
            </div>
        </modal>  
    </div>
</template>
<script>
    import BreadCrumb from '../components/cmpbreadcrumb.vue'
    import VueBootstrap4Table from 'vue-bootstrap4-table'
    import vPagination from 'vue-plain-pagination'
    import util from '../utilitarios/util.js'

    export default {
        name: 'cadcontasbancarias',
        components:{
            VueBootstrap4Table,
            vPagination,
            'breadcrumb' : BreadCrumb
        },
        data: function() {
            return {
                lstcontas  : [],
                pfiltro      : 1,
                pconteudo    : '',
                pqtdregistros: 10,
                pqtd_paginas : 1,
                pagina_atual : 1,
                pqtd_total_registros: 0,

                //variáveis do crud
                opcrud              :  0,
                vid                 : '',
                vdescricao          : '',
                vidbanco            : null,
                vidfilial           : null,
                vagencia            : '',
                vdigagencia         : '',
                vconta              : '',
                vdigconta           : '',
                vcedente            : '',
                vdigcedente         : '',
                vcodbeneficiario    : '',
                vdigbeneficiario    : '',
                vpraca              : '',
                vuf                 : '',
                vcnpjcpf            : '',
                vemitente           : '',
                vcarteira           : '',
                vconvenio           : '',
                vtpchavepix            : 0,
                vchavepix           : '',
                vinstrucao1         : '',
                vinstrucao2         : '',
                vmsgboleto          : '',
                vlocalpagamento     : '',
                vdiasprotesto       : 0,
                vespeciedoc         : '',
                vaceite             : 1,
                vlayoutremessa      : 3,
                vapibanco           : 0, 
                vvariacaocarteira   : '',
                //crud api's
                vtipoapi            : '0',
                vclientid           : '',
                vclientsecret       : '',
                vworkspaceid        : '',
                vcodposto           : '',
                vcodcooperativa     : '',
                vaccesstoken        : '',   // sicredi (gerado na pagina do desenvolvedor)
                vcodacesso          : '',   // sicredi (gerado pelo internet banking)
                vtipocobranca       : '',   // sicredi (NORMAL / HIBRIDO)
                vapiteste           : false, // verifica se a cb será de teste (sandbox)
                lstfilekey          : [],   // arquivo key
                lstfilecert         : [],   // arquivo certificado
                vnossonumero        : 1,
                vidcontadefns       : 0,
                vdiretorioarquivokey: '',
                vdiretorioarquivocrt: '',
                vapplicationkey    : '',   // banco do brasil (gerado na pagina do desenvolvedor)

                vchavepublica       : '',   // pagar me
                vchaveprivada       : '',   // pagar me

                lstwebhooksapi      : [],   // lista de webhooks da api
                vurlwebhook         : '',   // url do webhook

                //variável para habilitação dos campos
                ativadesativa       : true,
                ativadesativacheck  : false, // usado para switch de seleção da api teste

                bootstrapPaginationClasses: {
                    ul: 'pagination pagination-sm',
                    li: 'page-item',
                    liActive: 'active',
                    liDisable: 'disabled',
                    button: 'page-link'
                },
                itensbc : {
                    item1 : {
                        titulo : 'CONTAS BANCÁRIAS',
                        ativo  : false
                    },
                    item2 : {
                        titulo : '',
                        ativo  : false
                    }
                },
                columns: [
                    {
                        label: 'Opções',
                        name : 'opcoes',
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-center",
                        row_classes: "def-col-opcoes-conta",
                        sort: false
                    },
                    {
                        label: "Código",
                        name: "id",
                        sort: true,
                        slot_name: "id_f",
                        row_classes: "def-col-cod",
                    },
                    {
                        label: "Descrição",
                        name: "descricao",
                        initial_sort : true,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Banco",
                        name: "descbanco",
                        initial_sort : false,
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Id.",
                        name: "codigo",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Agência",
                        name: "agencia",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Conta",
                        name: "conta",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "API",
                        name: "apibanco",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        slot_name: 'api_f',
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                ],
                config: {
                    pagination: false,
                    pagination_info: false,
                    card_mode: false,
                    global_search: {
                        visibility: false,
                    },
                    show_refresh_button : false,
                    show_reset_button : false
                },
                classes: {
                    table: "table-bordered table-striped table-sm"
                }
            }
        },
        methods:{
            mtdconfirmagerarworkspacesantander(){
                let vself = this;
                $.confirm({
                    title: 'Confirmação!',
                    content: 'Confirma a criação do workspace da API Santander?',
                    icon: 'fa fa-question-circle',
                    escapeKey: true,
                    backgroundDismiss: false,
                    escapeKey: 'nao',
                    type: 'dark',
                    typeAnimated: true,
                    buttons: {
                        sim: {
                            text: '<u>S</u>im',
                            keys: ['s', 'S'],
                            btnClass: 'btn-blue',
                            action: function () {
                                vself.mtdgerarworkspacesantander();
                            }
                        },
                        nao: {
                            text: '<u>N</u>ão',
                            keys: ['n', 'N'],
                            action: function () {
                            }
                        }
                    }
                });
            },
            mtdgerarworkspacesantander(){
                if(this.vconvenio === ''){
                    this.$toastr.i('Informe o convênio para iniciar a API!', 'Informação!');
                    return;
                }
                var vself           = this;
                let loader          = this.$loading.show();
                let parametros      = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor  : 'criaworkspacesantander'},
                    {parametro: 'convenio',     valor  : vself.vconvenio},
                    {parametro: 'idconta',      valor  : vself.vid},
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadcontasbancarias.php');
                retorno.then(function (response) {
                    if (parseInt(response.data.inf) === 1){
                        vself.$toastr.s('Workspace criado com sucesso!', 'Informação!');
                        vself.vworkspaceid = response.data.workspaceid;
                    } else {
                        vself.$toastr.e(response.data.msg, 'Atenção!');
                    }
                    loader.hide();
                }).catch(function (response) {
                    console.log(response);
                    vself.$toastr.e('Erro ao criar workspace!', 'Erro!');
                    loader.hide();
                });

            },
            mtdconfirmalimparwebhooksantander(){
                let vself = this;
                $.confirm({
                    title: 'Confirmação!',
                    content: 'Confirma a exclusão do workspace da API Santander?',
                    icon: 'fa fa-question-circle',
                    escapeKey: true,
                    backgroundDismiss: false,
                    escapeKey: 'nao',
                    type: 'dark',
                    typeAnimated: true,
                    buttons: {
                        sim: {
                            text: '<u>S</u>im',
                            keys: ['s', 'S'],
                            btnClass: 'btn-blue',
                            action: function () {
                                vself.mtdlimparworkspacesantander();
                            }
                        },
                        nao: {
                            text: '<u>N</u>ão',
                            keys: ['n', 'N'],
                            action: function () {
                            }
                        }
                    }
                });
            },
            mtdlimparworkspacesantander(){
                if(this.vconvenio === ''){
                    this.$toastr.i('Informe o convênio para limpar o workspace da API!', 'Informação!');
                    return;
                }
                var vself           = this;
                // loader
                let loader      = this.$loading.show();
                let parametros      = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor  : 'limparworkspacesantander'},
                    {parametro: 'convenio',     valor  : vself.vconvenio},
                    {parametro: 'idconta',      valor  : vself.vid},
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadcontasbancarias.php');
                retorno.then(function (response) {
                    if ($.isNumeric(response.data)){
                        vself.$toastr.s('Workspace removido com sucesso!', 'Informação!');
                        vself.vworkspaceid = '';
                    }else{
                        let tpret = response.data.substring(0,1);
                        switch (tpret) {
                            case 'I':
                                vself.$toastr.w(response.data.substring(4), 'Atenção!');
                                break;
                            case 'E': default:
                                vself.$toastr.e(response.data.substring(4), 'Erro!');
                                break;
                        }
                    }
                    loader.hide();
                }).catch(function (error) {
                   console.log(error);
                    vself.$toastr.e('Erro ao limpar workspace!', 'Erro!');
                    loader.hide();
                });
            },
            mtdfiltropesquisa(){
                let rfiltro = '';
                if (parseInt(this.pfiltro) === 0){
                    rfiltro = this.pconteudo === '' ? '' : ' and c.id='+this.pconteudo;
                }else{
                    rfiltro = this.pconteudo === '' ? '' : ' and upper(c.descricao) like upper("'+this.pconteudo+'%")';
                }
                return rfiltro;
            },
            mtdexecutapesquisa(){
                var vself           = this;
                let filtro          = vself.mtdfiltropesquisa();
                this.pagina_atual   = 1;
                let parametros      = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor  : 'qtdregistros'},
                    {parametro: 'filtro',       valor  : filtro}
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadcontasbancarias.php');
                retorno.then(function (response) {
                    vself.pqtd_total_registros = parseInt(response.data.qtdregistros);
                    let qtdpg                  = Math.ceil(vself.pqtd_total_registros / vself.pqtdregistros);
                    vself.pqtd_paginas         = qtdpg > 0 ? qtdpg : 1;
                    vself.mtdcarregacontas(1);
                }).catch(function (response) {
                    alert('Erro ao consultar registros');
                });
            },
            mtdcarregacontas(ipagina){
                var vself       = this;
                let loader      = this.$loading.show();
                let filtro      = vself.mtdfiltropesquisa();
                let parametros  = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor : 'listagem'},
                    {parametro: 'filtro',       valor : filtro},
                    {parametro: 'limit',        valor : vself.pqtdregistros},
                    {parametro: 'offset',       valor : (parseInt(ipagina) -1) * parseInt(vself.pqtdregistros)},
                ];
                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadcontasbancarias.php');
                retorno.then(function (response) {
                    vself.lstcontas = response.data.lista;
                    loader.hide();
                }).catch(function (response) {
                    vself.lstcontas = [];
                    loader.hide();
                });
            },
			mtdselect2_def(){
                let vself  = this;
				$('#mddefinirnossonumero').on('shown.bs.modal', function (e) {
                    let loader      = vself.$loading.show();
                    let parametros  = [
                        {parametro: 'op',           valor : 'listagem'},
                        {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                        {parametro: 'filtro',       valor : ""},
                        {parametro: 'codencontrar', valor : vself.vidcontadefns},
                        {parametro: 'limit',        valor : 1},
                        {parametro: 'offset',       valor : 0},
                    ];
                    let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadcontasbancarias.php');
                    retorno.then(function (response) {
                        loader.hide();
                        vself.vnossonumero = response.data.nossonumero;
                        $('#ednossonumero').focus();
                    }).catch(function (response) {
                        loader.hide();
                    });                    					
                });            
                    
				$("#cbbancos").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbbancos',
								c1: 'id',
								c2: 'descricao'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.vidbanco = $("#cbbancos").val();
				});

                $("#cbfilial").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbfiliais',
								c1: 'codfil',
								c2: 'descfil'
							};
						},
						processResults: function (data) {
							return {
								results: data,
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.vidfilial = $("#cbfilial").val();
				});         
			},            
            resetarDados() {
                util.toTop();
                this.vid                = '';
                this.vdescricao         = '';
                this.vidbanco			= null;
                this.vidfilial			= null;
                this.vagencia			= '';
                this.vdigagencia		= '';
                this.vconta         	= '';
                this.vdigconta          = '';
                this.vcedente         	= '';
                this.vdigcedente        = '';
                this.vcodbeneficiario   = '';
                this.vdigbeneficiario   = '';
                this.vpraca         	= '';
                this.vuf         		= '';
                this.vcnpj           	= '';
                this.vemitente          = '';
                this.vcarteira          = '';
                this.vconvenio          = '';
                this.vtpchavepix           = 0;
                this.vchavepix          = '';
                this.vinstrucao1        = '';
                this.vinstrucao2        = '';
                this.vdiasprotesto      = 0;
                this.vespeciedoc        = '';
                this.vaceite          	= 1;
                this.vlayoutremessa     = 3;
                this.vapibanco          = 0;
                this.vvariacaocarteira  = '';
                this.vtipoapi           = '0'; // 0 - boleto | 1 - pix
                // crud contas bancarias
                this.vclientid          = '';
                this.vclientsecret      = '';
                // api sicredi
                this.vcodposto          = '';
                this.vcodcooperativa    = '';
                this.vtipocobranca      = '';
                this.vapiteste          = false;
                this.vaccesstoken       = '';
                this.vcodacesso         = '';
                this.ativadesativacheck = false;
                this.vapplicationkey    = '';

                // api inter, sicoob, santander e bb

                this.vdiretorioarquivokey = '';
                this.vdiretorioarquivocrt = '';
                this.vworkspaceid         = '';
                // api pagarme
                this.vchavepublica      = '';
                this.vchaveprivada      = '';
                $("#cbbancos").val(null).trigger('change');
                $("#cbfilial").val(null).trigger('change');
                //webhooks
                this.vurlwebhook        = '';
                this.lstwebhooksapi     = [];
            },
            mtddefault(){
                $('#pnlista').hide();
                this.resetarDados();
                $('#pncadastro').fadeIn(700);
                this.$nextTick(function () {
                    if (parseInt(this.opcrud) < 3) {
                        $('#eddescricao').focus();
                    } else {
                        $('#btgravar').focus();
                    }
                });
            },
            mtdpreparacrud(op) {
                let vself    = this;
                vself.opcrud = op;
                $('.nav-tabs a[href="#dvperfil"]').tab('show');
                vself.mtddefault();
            },
            mtdnovo(){
                if (!util.opcaousuario('002Z.030M.010Z', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else {
                    this.itensbc.item2.titulo = 'INCLUSÃO DE CONTAS BANCÁRIAS';
                    this.itensbc.item1.ativo = true;
                    this.itensbc.item2.ativo = true;
                    this.ativadesativa = false;
                    this.mtdpreparacrud(1);
                }
            },
            mtdcancelaredicao(){
                if (parseInt(this.opcrud) === 1) {
                    if (this.vdiretorioarquivokey){
                        this.mtdeletararquivo('key')
                    }
                    if (this.vdiretorioarquivocrt){
                        this.mtdeletararquivo('crt')
                    }
                }
                this.itensbc.item1.ativo = false;
                this.itensbc.item2.ativo = false;
                $('#pncadastro').hide();
                $('#pnlista').fadeIn(700);
                $('#edconteudopesq').focus();
                setTimeout(function(){
                    util.toTop();
                }, 200);
            },
            mtdlimpar_listagem() {
                this.lstcontas = [];
                this.pagina_atual = 1;
                this.filtro = '';
                this.pqtd_total_registros = 0;
                this.pqtd_paginas = 0;
            },
            mtdgravar(){
                let vself = this;
                if (parseInt(vself.opcrud) < 3) {
                    if (parseInt(vself.vtodasfiliais) === 0) {
                    }
                }
                $.confirm({
                    title: 'Confirmação!',
                    content: 'Confirma ' + vself.itensbc.item2.titulo + '?',
                    icon: 'fa fa-question-circle',
                    escapeKey: true,
                    backgroundDismiss: false,
                    escapeKey: 'nao',
                    type: 'dark',
                    typeAnimated: true,
                    buttons: {
                        sim: {
                            text: '<u>S</u>im',
                            keys: ['s', 'S'],
                            btnClass: 'btn-blue',
                            action: function () {
                                $('.btn-blue').prop('disabled', true);
                                vself.mtdregistro();
                                if (parseInt(vself.opcrud) === 3) {
                                    if (vself.vdiretorioarquivokey){
                                        vself.mtdeletararquivo('key')
                                    }
                                    if (vself.vdiretorioarquivocrt){
                                        vself.mtdeletararquivo('crt')
                                    }
                                }
                            }
                        },
                        nao: {
                            text: '<u>N</u>ão',
                            keys: ['n', 'N'],
                            action: function () {
                                $('#btgravar').focus();
                            }
                        }
                    }
                });
            },
            mtdlocalizaregistro(id){
                var vself       = this;
                let loader      = vself.$loading.show();
                let filtro      = ' and c.id='+id;
                let parametros  = [
                    {parametro: 'op',           valor : 'listagem'},
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'filtro',       valor : filtro},
                    {parametro: 'limit',        valor : 1},
                    {parametro: 'offset',       valor : 0},
                ];
                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadcontasbancarias.php');
                retorno.then(function (response) {
                    loader.hide();
                    vself.mtdigualarcampos(response.data.lista[0]);
                    if (parseInt(vself.opcrud) < 3){
                        $('#eddescricao').focus();
                    }else{
                        $('#btgravar').focus();
                    }
                }).catch(function (response) {
                    loader.hide();
                });
            },
            mtdalterar(item){
                if (!util.opcaousuario('002Z.030M.020Z', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else {
                    this.itensbc.item2.titulo = 'ALTERAÇÃO DE CONTAS BANCÁRIAS';
                    this.itensbc.item1.ativo = true;
                    this.itensbc.item2.ativo = true;
                    this.ativadesativa = false;
                    this.mtdpreparacrud(2);
                    this.mtdlocalizaregistro(item.id);
                }
            },
            mtdexcluir(item){
                if (!util.opcaousuario('002Z.030M.030Z', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else {
                    this.itensbc.item2.titulo = 'EXCLUSÃO DE CONTAS BANCÁRIAS';
                    this.itensbc.item1.ativo = true;
                    this.itensbc.item2.ativo = true;
                    this.ativadesativa = true;
                    this.mtdpreparacrud(3);
                    this.mtdlocalizaregistro(item.id);
                }
            },
            mtdigualarcampos(registro){
                this.vid                    = registro.id;
                this.vdescricao             = registro.descricao;
                this.vidbanco			    = registro.idbanco;
                this.vidfilial			    = registro.idfilial;
                this.vagencia			    = registro.agencia;
                this.vdigagencia		    = registro.digagencia;
                this.vconta         	    = registro.conta;
                this.vdigconta              = registro.digconta;
                this.vcedente         	    = registro.cedente;
                this.vdigcedente            = registro.digcedente;
                this.vcodbeneficiario       = registro.codbeneficiario;
                this.vdigbeneficiario       = registro.digbeneficiario;
                this.vpraca         	    = registro.praca;
                this.vuf         		    = registro.uf;
                this.vcnpjcpf         	    = registro.cnpjcpf;
                this.vemitente              = registro.emitente;
                this.vcarteira              = registro.carteira;
                this.vconvenio              = registro.convenio;
                this.vtpchavepix               = registro.tpchavepix;
                this.vchavepix              = registro.chavepix;
                this.vinstrucao1            = registro.instrucao1;
                this.vinstrucao2            = registro.instrucao2;
                this.vdiasprotesto          = registro.diasprotesto;
                this.vespeciedoc            = registro.especiedoc;
                this.vaceite          	    = registro.aceite;
                this.vlayoutremessa         = registro.layoutremessa;
                this.vapibanco              = registro.apibanco;
                this.vvariacaocarteira      = registro.variacaocarteira;
                this.vtipoapi               = registro.tpapibanco;
                // crud contas bancarias
                this.vclientid              = registro.clientid;
                this.vclientsecret          = registro.clientsecret;
                // api sicredi
                this.vcodposto              = registro.codposto;
                this.vcodcooperativa        = registro.codcooperativa;
                this.vtipocobranca          = registro.tipocobranca == null ? '' : registro.tipocobranca;
                this.vapiteste              = registro.apiteste == 0 ? false : true;
                this.vaccesstoken           = registro.accesstoken;
                this.vcodacesso             = registro.codacesso;
                // api inter santander bb
                this.vdiretorioarquivokey   = registro.diretorioarquivokey;
                this.vdiretorioarquivocrt   = registro.diretorioarquivocrt;
                this.vworkspaceid           = registro.workspaceid;
                // api pagarme
                this.vchavepublica          = registro.chavepublica;
                this.vchaveprivada          = registro.chaveprivada;
                this.vapplicationkey        = registro.applicationkey;

                var defbanco    = new Option(registro.descbanco, this.vidbanco, true, true);
                $('#cbbancos').append(defbanco).trigger('change');                
                var deffilial    = new Option(registro.descfilial, this.vidfilial, true, true);
                $('#cbfilial').append(deffilial).trigger('change');                
            },
            mtdregistro(){
                let vself  = this;
                let loader = vself.$loading.show();
                let registrocrud = {
                    'id'                : this.vid,
                    'descricao'         : this.vdescricao,
                    'idbanco' 			: this.vidbanco,
                    'idfilial' 			: this.vidfilial,
                    'agencia' 			: this.vagencia,
                    'digagencia' 		: this.vdigagencia,
                    'conta' 			: this.vconta,
                    'digconta' 			: this.vdigconta,
                    'cedente' 			: this.vcedente,
                    'digcedente' 		: this.vdigcedente,
                    'codbeneficiario' 	: this.vcodbeneficiario,
                    'digbeneficiario' 	: this.vdigbeneficiario,
                    'praca' 			: this.vpraca,
                    'uf' 				: this.vuf,
                    'cnpjcpf' 			: this.vcnpjcpf,
                    'emitente' 			: this.vemitente,
                    'carteira' 			: this.vcarteira,
                    'convenio' 			: this.vconvenio,
                    'tpchavepix'        : this.vtpchavepix,
                    'chavepix' 			: this.vchavepix,
                    'instrucao1' 		: this.vinstrucao1,
                    'instrucao2' 		: this.vinstrucao2,
                    'msgboleto' 		: this.vmsgboleto,
                    'localpagamento'	: this.vlocalpagamento,
                    'diasprotesto' 		: this.vdiasprotesto,
                    'especiedoc' 		: this.vespeciedoc,
                    'aceite' 			: this.vaceite,
                    'layoutremessa' 	: this.vlayoutremessa,
                    'apibanco'          : this.vapibanco,
                    'variacaocarteira'  : this.vvariacaocarteira,
                    'tpapibanco'        : this.vtipoapi,
                    // crud contas bancarias
                    'clientid'           : this.vclientid,
                    'clientsecret'       : this.vclientsecret,
                    // api sicredi
                    'codposto'           : this.vcodposto,
                    'codcooperativa'     : this.vcodcooperativa,
                    'tipocobranca'       : this.vtipocobranca,
                    'apiteste'           : this.vapiteste ? '1' : '0',
                    'accesstoken'        : this.vaccesstoken,
                    'codacesso'          : this.vcodacesso,
                    'diretorioarquivokey': this.vdiretorioarquivokey,
                    'diretorioarquivocrt': this.vdiretorioarquivocrt,
                    'workspaceid'        : this.vworkspaceid,
                    // api pagarme
                    'chavepublica'       : this.vchavepublica,
                    'chaveprivada'       : this.vchaveprivada,
                    // api banco do brasil
                    'applicationkey'     : this.vapplicationkey,
                };
                let parametros      = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor : 'rotinacrud'},
                    {parametro: 'opcrud',       valor : vself.opcrud},
                    {parametro: 'registro',     valor : JSON.stringify(registrocrud)},
                    {parametro: 'idfilial',     valor : vself.$store.state.filialpadrao.codfil},
                    {parametro: 'idusuario',    valor : vself.$store.state.usuario.id},
                    {parametro: 'codop',        valor : parseInt(this.opcrud) === 1 ? '002Z.030M.010Z' : parseInt(this.opcrud) === 2 ? '002Z.030M.020Z' : '002Z.030M.030Z'},
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadcontasbancarias.php');
                retorno.then(function (response) {
                    loader.hide();
                    if ($.isNumeric(response.data)){
                        vself.$toastr.s('Registro processado com sucesso!', 'Informação!');
                        vself.pfiltro       = 0;
                        vself.pconteudo     = parseInt(vself.opcrud) === 1 ? response.data : vself.vid;
                        vself.pqtd_paginas  = 1;

                        vself.mtdcancelaredicao();
                        vself.mtdcarregacontas(1);
                    }else{
                        let tpret = response.data.substring(0,1);
                        switch (tpret) {
                            case 'I':
                                vself.$toastr.w(response.data.substring(4), 'Atenção!');
                                break;
                            case 'E': default:
                                vself.$toastr.e(response.data.substring(4), 'Erro!');
                                break;
                        }
                    }
                }).catch(function (response) {
                    loader.hide();
                    vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
                });
            },
            mtddefinirnossonumero(idconta){
                this.vidcontadefns = idconta;
                $('#mddefinirnossonumero').modal('show');
            },
            mtconfirmarnossonumero(){
                let vself = this;
                if (vself.vnossonumero === ''){
                    vself.$toastr.w('Campo Nosso Número deve ser informado!', 'Atenção!');
                    $('#ednossonumero').focus();
                    return;
                }
                $.confirm({
                    title: 'Confirmação!',
                    content: 'Esse processo irá reiniciar o contador do campo "Nosso Número" para emissão dos boletos desta conta. Confirma esta operação?',
                    icon: 'fa fa-question-circle',
                    escapeKey: true,
                    backgroundDismiss: false,
                    escapeKey: 'nao',
                    type: 'dark',
                    typeAnimated: true,
                    buttons: {
                        sim: {
                            text: '<u>S</u>im',
                            keys: ['s', 'S'],
                            btnClass: 'btn-blue',
                            action: function () {
                                $('.btn-blue').prop('disabled', true);
                                let loader      = vself.$loading.show();
                                let parametros  = [
                                    {parametro: 'op',           valor : 'definenossonumero'},
                                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                                    {parametro: 'id',           valor : vself.vidcontadefns},
                                    {parametro: 'nossonumero',  valor : vself.vnossonumero}
                                ];
                                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadcontasbancarias.php');
                                retorno.then(function (response) {
                                    loader.hide();
                                    if ($.isNumeric(response.data)){
                                        vself.$toastr.s('Nosso número definido com sucesso!', 'Informação!');
                                        $('#mddefinirnossonumero').modal('hide');
                                    }else{
                                        let tpret = response.data.substring(0,1);
                                        switch (tpret) {
                                            case 'I':
                                                vself.$toastr.w(response.data.substring(4), 'Atenção!');
                                                break;
                                            case 'E': default:
                                                vself.$toastr.e(response.data.substring(4), 'Erro!');
                                                break;
                                        }
                                    }
                                }).catch(function (response) {
                                    loader.hide();
                                });                    					                                
                            },
                        },
                        nao: {
                            text: '<u>N</u>ão',
                            keys: ['n', 'N'],
                            action: function () {
                                $('#btgravar').focus();
                            }
                        }
                    }
                });                
            },
            mtdisparabtenviarquivokey: function () {
                if(this.vdiretorioarquivokey){  
                    this.$toastr.i("Já existe um arquivo anexado!", 'Atenção');
                    return
                }
                if(this.vagencia === ''){  
                    this.$toastr.i("Informe primeiro o numero da agencia!", 'Atenção');
                    return
                }
                if(this.vconta=== ''){  
                    this.$toastr.i("Informe primeiro o numero da conta!", 'Atenção');
                    return
                }
                const file               = document.querySelector('#btenviararquivokey');
                file.value               = '';
                $('#btenviararquivokey').trigger('click');
            },
            mtdisparabtenviarquivocert: function () {
                if(this.vdiretorioarquivocrt){  
                    this.$toastr.i("Já existe um arquivo anexado!", 'Atenção');
                    return
                }
                if(this.vagencia === ''){  
                    this.$toastr.i("Informe primeiro o numero da agencia!", 'Atenção');
                    return
                }
                if(this.vconta=== ''){  
                    this.$toastr.i("Informe primeiro o numero da conta!", 'Atenção');
                    return
                }
                const file               = document.querySelector('#btenviararquivocert');
                file.value               = '';
                $('#btenviararquivocert').trigger('click');
            },
            mtenviararquivo(event) {
                let vself = this;
                let arquivo = event.target.files[0];
                let ext = util.extensaoarquivo(arquivo).toLowerCase();
                let localsalvar = '';
                let loader      = vself.$loading.show();
                let stringAleatoria = util.GerarStringAleatoria(10);
                
                switch (parseInt(this.vapibanco)) {
                    case 1://inter
                        localsalvar = 'controller/arquivoscontasbancarias/' + vself.$store.state.filialpadrao.idcliente+'/'+vself.vagencia+vself.vconta+'/'+stringAleatoria+'/certificadointer/'+ext;
                        break;
                        
                    case 3://sicoob
                        localsalvar = 'controller/arquivoscontasbancarias/' + vself.$store.state.filialpadrao.idcliente+'/'+vself.vagencia+vself.vconta+'/'+stringAleatoria+'/certificadosicoob/'+ext;
                        break;
                        
                    case 4://santander
                        localsalvar = 'controller/arquivoscontasbancarias/' + vself.$store.state.filialpadrao.idcliente+'/'+vself.vagencia+vself.vconta+'/'+stringAleatoria+'/certificadosantander/'+ext;
                        break;     

                    case 5:// bb
                        localsalvar = 'controller/arquivoscontasbancarias/' + vself.$store.state.filialpadrao.idcliente+'/'+vself.vagencia+vself.vconta+'/'+stringAleatoria+'/certificadobancobrasil/'+ext;
                        break;     
                }

                let parametros      = [
                    {parametro: 'arquivo',          valor  : arquivo},
                    {parametro: 'localsalvar',      valor  : localsalvar},
                    {parametro: 'nomearquivo',      valor  : arquivo.name}
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/uploadfile.php');
                retorno.then(function (response) {
                    if ($.isNumeric(response.data.inf)) {
                        loader.hide();
                        let localarquivo = localsalvar+'/'+arquivo.name;
                        let op = ext === 'key' ? 'registraarquivokey' : 'registraarquivocrt';
                        let parametros      = [
                            {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                            {parametro: 'idconta',      valor  : vself.vid},
                            {parametro: 'op',           valor  : op},
                            {parametro: 'localarquivo', valor  : localarquivo}
                        ];
                        let retorno2     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadcontasbancarias.php');
                        retorno2.then(function (response) {
                            if ($.isNumeric(response.data.inf)){
                                if (ext == 'key') {
                                    vself.vdiretorioarquivokey = localsalvar+'/'+arquivo.name;
                                    vself.$toastr.s('Arquivo da chave enviada com sucesso!', 'Informação!');
                                } else {
                                    vself.vdiretorioarquivocrt = localsalvar+'/'+arquivo.name;
                                    vself.$toastr.s('Arquivo de certificado enviado com sucesso!', 'Informação!');
                                }
                            } else {
                                vself.$toastr.e('Não foi possível enviar o arquivo!', 'Erro!');
                            }
                        }).catch(function (response) {
                            vself.$toastr.e('Descrição do erro: '+response.message, 'Erro!');
                        }); 
                    }else{
                        loader.hide();
                        vself.$toastr.e('Descrição do erro: '+response.data, 'Erro!');
                    }                   
                }).catch(function (response) {
                    loader.hide();
                    if (ext == 'key') {
                        vself.vdiretorioarquivokey = '';
                        vself.$toastr.e('Descrição do erro: '+response.message, 'Erro!');
                    } else {
                        vself.vdiretorioarquivocrt = '';
                        vself.$toastr.e('Descrição do erro: '+response.message, 'Erro!');
                    }                      
                });       
            },
            mtdeletararquivo(ext){
                let vself           = this;
                let loader          = vself.$loading.show();
                let localarquivo    = 'controller/arquivoscontasbancarias/' + vself.$store.state.filialpadrao.idcliente+'/'+vself.vagencia+vself.vconta+'/certificadointer/'+ext;
                let patharquivo     = ext === 'key' ? vself.vdiretorioarquivokey : vself.vdiretorioarquivocrt;
                
                let parametros      = [
                    {parametro: 'op',               valor  : "excluiarquivocrt"},
                    {parametro: 'idclientesac',     valor  : vself.$store.state.usuario.idclientesac},
                    {parametro: 'idconta',          valor  : vself.vid},
                    {parametro: 'ext',              valor  : ext},
                    {parametro: 'patharquivo',      valor  : patharquivo},
                    {parametro: 'localarquivo',     valor  : localarquivo}
                    
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadcontasbancarias.php');
                retorno.then(function (response) {
                    if ($.isNumeric(response.data.inf)){
                        vself.$toastr.s('Arquivo excluído com sucesso!', 'Informação!');
                        if (ext === 'key'){
                            vself.vdiretorioarquivokey = '';
                        } else {
                            vself.vdiretorioarquivocrt = '';
                        }
                    }else{
                        vself.$toastr.e('Erro ao excluir arquivos: '+response.data.inf, 'Erro!');
                    }
                    loader.hide();
                }).catch(function (response) {
                    loader.hide();
                    vself.$toastr.e('Erro ao excluir arquivo: '+response.message, 'Erro!');
                });                  
            },
            mtdconfigurarwebhook(){
                if (this.opcrud == 1 || this.opcrud == 3) {
                    this.$toastr.i('Operação não permitida para inclusão ou exclusão!', 'Informação!');
                } else {
                    this.mtdlistawebhooks();
                    this.$modal.show('mdl-config-webhook');
                }
            },
            mtdcancelaconfigwebhook(){
                this.$modal.hide('mdl-config-webhook');
                this.vurlwebhook = '';
                this.lstwebhooksapi = [];
            },
            mtdlistawebhooks(){
                let vself = this;
                let loader = vself.$loading.show();
                let parametros = [
                    {parametro: 'op',               valor: 'listarwebhooks'},
                    {parametro: 'idclientesac',     valor: vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'idfilial',         valor: vself.$store.state.filialpadrao.codfil},
                    {parametro: 'idconta',          valor: vself.vid},
                    {parametro: 'apibanco',         valor: vself.vapibanco},
                    {parametro: 'chavepix',         valor: vself.vchavepix.replace(/[^a-zA-Z0-9]/g, '')},
                    {parametro: 'tpapibanco',       valor: vself.vtipoapi},
                ];
                let retorno = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadcontasbancarias.php');
                retorno.then(function (response) {
                    vself.lstwebhooksapi = response.data;
                    if (vself.lstwebhooksapi.length == 0){
                        vself.$toastr.i('Nada encontrado. Para webhooks recém vinculados, ele pode demorar a ser listado.', 'Informação!');
                    }
                    loader.hide();
                }).catch(function (response) {
                    vself.lstwebhooksapi = [];
                    vself.$toastr.e('Erro ao listar webhooks: '+response.message, 'Erro!');
                    loader.hide();
                });
            },
            mtdconfirmacadastrowebhook(){
                let vself = this;
                if (vself.vurlwebhook == ''){
                    vself.$toastr.w('Informe a URL do webhook!', 'Atenção!');
                    $('#edurlwebhook').focus();
                    return;
                }
                $.confirm({
                    title: 'Confirmação!',
                    content: 'Confirma o cadastro do webhook?',
                    icon: 'fa fa-question-circle',
                    escapeKey: true,
                    backgroundDismiss: false,
                    escapeKey: 'nao',
                    type: 'dark',
                    typeAnimated: true,
                    buttons: {
                        sim: {
                            text: '<u>S</u>im',
                            keys: ['s', 'S'],
                            btnClass: 'btn-blue',
                            action: function () {
                                $('.btn-blue').prop('disabled', true);
                                vself.mtdcadastrawebhook();
                            }
                        },
                        nao: {
                            text: '<u>N</u>ão',
                            keys: ['n', 'N'],
                            action: function () {
                                $('#edurlwebhook').focus();
                            }
                        }
                    }
                });
            },
            mtdcadastrawebhook(){
                let vself = this;
                let loader = vself.$loading.show();
                let parametros = [
                    {parametro: 'op',               valor: 'cadastrarwebhook'},
                    {parametro: 'idclientesac',     valor: vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'idfilial',         valor: vself.$store.state.filialpadrao.codfil},
                    {parametro: 'idconta',          valor: vself.vid},
                    {parametro: 'apibanco',         valor: vself.vapibanco},
                    {parametro: 'chavepix',         valor: vself.vchavepix},
                    {parametro: 'urlwebhook',       valor: vself.vurlwebhook},
                    {parametro: 'tpapibanco',       valor: vself.vtipoapi},
                ];
                let retorno = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadcontasbancarias.php');
                retorno.then(function (response) {
                    if (response.data == 1){
                        vself.$toastr.s('Webhook cadastrado com sucesso!', 'Informação!');
                        vself.vurlwebhook = '';
                    }else {
                        vself.$toastr.e(JSON.stringify(response.data), 'Erro!');
                    }
                    vself.mtdlistawebhooks();
                    loader.hide();
                }).catch(function (response) {
                    vself.$toastr.e('Erro ao cadastrar webhook: '+response.message, 'Erro!');
                    vself.mtdlistawebhooks();
                    loader.hide();
                });
            },
            mtdconfirmadesvincularwebhook(item){
                let vself = this;
                $.confirm({
                    title: 'Confirmação!',
                    content: 'Confirma a desvinculação do webhook?',
                    icon: 'fa fa-question-circle',
                    escapeKey: true,
                    backgroundDismiss: false,
                    escapeKey: 'nao',
                    type: 'dark',
                    typeAnimated: true,
                    buttons: {
                        sim: {
                            text: '<u>S</u>im',
                            keys: ['s', 'S'],
                            btnClass: 'btn-blue',
                            action: function () {
                                $('.btn-blue').prop('disabled', true);
                                vself.mtddesvincularwebhook(item);
                            }
                        },
                        nao: {
                            text: '<u>N</u>ão',
                            keys: ['n', 'N'],
                            action: function () {
                                $('#edurlwebhook').focus();
                            }
                        }
                    }
                });
            },
            mtddesvincularwebhook(item){
                let vself = this;
                let loader = vself.$loading.show();
                let parametros = [
                    {parametro: 'op',               valor: 'desvincularwebhook'},
                    {parametro: 'idclientesac',     valor: vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'idfilial',         valor: vself.$store.state.filialpadrao.codfil},
                    {parametro: 'idconta',          valor: vself.vid},
                    {parametro: 'apibanco',         valor: vself.vapibanco},
                    {parametro: 'chavepix',         valor: item.chave},
                    {parametro: 'tpapibanco',       valor: vself.vtipoapi},
                ];
                let retorno = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadcontasbancarias.php');
                retorno.then(function (response) {
                    if (response.data == 1){
                        vself.$toastr.s('Webhook desvinculado com sucesso!', 'Informação!');
                    }else {
                        vself.$toastr.e(response.data, 'Erro!');
                    }
                    vself.mtdlistawebhooks();
                    loader.hide();
                }).catch(function (response) {
                    vself.$toastr.e('Erro ao desvincular webhook: '+response.message, 'Erro!');
                    vself.mtdlistawebhooks();
                    loader.hide();
                });
            },
            ativaDesativaDefNossoNum(apiBanco){
                return (apiBanco != 0 &&
                        apiBanco != 4 &&
                        apiBanco != 5)
            },
        },
        mounted: function () {
            if (util.verificasessao(this)) {
                let vself = this;
                let loader = vself.$loading.show();
                let parametros = [
                    {parametro: 'op', valor: 'dadosusuario'},
                    {parametro: 'idclientesac', valor  : vself.$store.state.usuario.idclientesac},
                    {parametro: 'idusuario', valor: vself.$store.state.usuario.id}
                ];
                let retorno = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rotinasusuario.php');
                retorno.then(function (response) {
                    loader.hide();
                    vself.$store.commit('MUDAR_PERFIL_USUARIO', response.data.perfilusu);
                    if (parseInt(vself.$store.state.filialpadrao.plnc) < 2){
                        vself.$swal.fire({
                                            position: 'bottom-end',
                                            //icon: 'success',
                                            title: 'Atenção!',
                                            html: 'Seu plano não contempla esta funcionalidade! Favor entrar em contato com a <strong>Rillsoft Sistemas</strong> para mais informações.',
                                            showConfirmButton: false,
                                            showCloseButton: true,
                                            backdrop: false                                                
                                        }); 
                        setTimeout(function(){
                            util.gotoprincipal();
                        },4000);                                                               
                    }
                    if (util.opcaousuario('002Z.030M', vself.$store.state.perfilusuario)) {
                        $('#pnlista').fadeIn(700);

                        vself.mtdexecutapesquisa();
                        vself.mtdselect2_def();
                        // vself.$modal.show('mdl-config-webhook'); // TIRAR
                    } else {
                        vself.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                        setTimeout(function(){
                            util.gotoprincipal();
                        },1000);
                    }
                }).catch(function (response) {
                    loader.hide();
                });
            }
        },
        computed:{
            validou() {
                if (this.vapibanco == 1) { // VALIDA API BANCO INTER
                    if(!this.vapiteste){
                        return  this.vdescricao             === '' ||
                                this.vidbanco               === null ||
                                this.vidfilial              === null ||
                                this.vagencia               === '' ||
                                this.vconta                 === '' ||
                                this.vclientid              === '' ||
                                this.vclientsecret          === '' ||
                                this.vdiretorioarquivokey   === '' ||
                                this.vdiretorioarquivocrt   === '' 
                    } else {
                        return  this.vdescricao         === '' ||
                                this.vidbanco           === null ||
                                this.vidfilial          === null ||
                                this.vagencia           === '' ||
                                this.vconta             === ''
                    }
                } else if (this.vapibanco == 2) { // VALIDA API SICREDI
                    if (!this.vapiteste) {
                        return  this.vdescricao         === '' ||
                                this.vidbanco           === null ||
                                this.vagencia           === '' ||
                                this.vconta             === '' ||
                                this.vaccesstoken       === '' ||
                                this.vcodacesso         === '' ||
                                this.vtipocobranca      === '' ||
                                this.vcodposto          === '' ||
                                this.vcodcooperativa    === '' ||
                                this.vcodbeneficiario   === '' ||
                                this.vidfilial          === null
                    } else {
                        return  this.vdescricao         === '' ||
                                this.vidbanco           === null ||
                                this.vidfilial          === null ||
                                this.vagencia           === '' ||
                                this.vconta             === ''
                    }
                } else if (this.vapibanco == 3) { // VALIDA API BANCO SICOOB
                    if(!this.vapiteste){
                        return  this.vdescricao             === '' ||
                                this.vidbanco               === null ||
                                this.vidfilial              === null ||
                                this.vagencia               === '' ||
                                this.vconta                 === '' ||
                                this.vclientid              === '' ||
                                this.vdiretorioarquivokey   === '' ||
                                this.vdiretorioarquivocrt   === '' 
                    } else {
                        return  this.vdescricao         === '' ||
                                this.vidbanco           === null ||
                                this.vidfilial          === null ||
                                this.vagencia           === '' ||
                                this.vconta             === ''
                    }
                } else if (this.vapibanco == 21) { // VALIDA API PAGARME
                    return  this.vdescricao             === '' ||
                            this.vidbanco               === null ||
                            this.vidfilial              === null ||
                            this.vchavepublica          === '' ||
                            this.vchaveprivada          === ''

                } else { // VALIDA SEM API
                    return  this.vdescricao         === '' ||

                            this.vidbanco           === null;
                }
            },
            ativadesativaapi (){
                if(this.ativadesativa) {
                    this.ativadesativacheck = true;
                    return true
                } else {
                    this.ativadesativacheck = false;
                    return false
                }
            },
            verificaSandbox(){
                // Verifica se a API possui suporte para sandbox

                // Por enquanto eu inutilizei essa variável, pois não há necessidade de desabilitar a checkbox
                // caso haja algum conflito futuro, utilizar para habilitar ou não a checkbox sandbox - Rodrigo 06/01/2025
                
                // Colocar return true para habilitar a checkbox sandbox
                if (parseInt(this.vapibanco) === 1){ // BANCO INTER
                    return true
                } else if(parseInt(this.vapibanco) === 2){ // BANCO SICREDI
                    return true
                } else if(parseInt(this.vapibanco) === 3){ // BANCO SICOOB
                    return true
                } else if(parseInt(this.vapibanco) === 4){ // BANCO SANTANDER
                    return true
                } else if(parseInt(this.vapibanco) === 5) { // BANCO DO BRASIL
                    return true
                } else {
                    return false
                }
            },
            habilitaCampos(){
                if((parseInt(this.vapibanco) === 0) || 
                    (parseInt(this.vapibanco) === 4) || 
                    (parseInt(this.vapibanco) === 5) 
                ){
                    return true;
                }else{
                    return false;
                }
                
                // return this.vapibanco != 0 ?  this.vapibanco != 0 ? false : true 
            },
        },
        watch:{
            pagina_atual(val){
                this.mtdcarregacontas(val);
            },
            apibanco(val){
                $("#meuElemento").toggleClass("minhaClasse");
            },
            vchavepix(val){
                if (this.vtpchavepix == 3) {
                    this.vchavepix = val;
                } else {
                    this.vchavepix = val.replace(/[^\w\s]/gi, '');
                }
            }
        }
    }
</script>
<style>
    .def-col-opcoes-conta{
        width: 140px !important;
    }
    .def-col-cod{
        width: 80px !important;
    }
    .btn-config-whook{
        background-color: transparent;
        border: none;
        color: #414038;
        font-size: 1.5em;
        width: fit-content;
        height: fit-content;
        margin-top: auto;
        margin-left: auto;
    }

    .btns-config-whook{
        display: flex;
        justify-content: end;

        & > button {
            margin-left: 10px;
        }
    }

    
</style>